import { useCallback } from 'react';
import type { MumulLivePost } from 'shared/src/api';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

/**
 * 무물라이브 콘텐츠 모아보기 바텀시트 노출·클릭 로깅.
 * SCREEN / 마켓 defaults 는 MarketAnalyticsProvider 가 자동 주입한다.
 */
export const useLogMumulLiveContents = (profileSno: number) => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  const buildPostAnalytics = useCallback(
    (post: MumulLivePost) => ({
      PROFILE_SNO: profileSno.toString(),
      POST_SNO: post.sno.toString(),
      POST_TYPE: post.post_type,
    }),
    [profileSno],
  );

  const logDisplayMumulLivePost = useCallback(
    (post: MumulLivePost) => {
      logMarketAnalytics({
        name: 'DISPLAY_MUMUL_LIVE_POST',
        analytics: buildPostAnalytics(post),
      });
    },
    [logMarketAnalytics, buildPostAnalytics],
  );

  const logClickMumulLivePost = useCallback(
    (post: MumulLivePost) => {
      logMarketAnalytics({
        name: 'CLICK_MUMUL_LIVE_POST',
        analytics: buildPostAnalytics(post),
      });
    },
    [logMarketAnalytics, buildPostAnalytics],
  );

  const logClickMumulLivePostViewMore = useCallback(() => {
    logMarketAnalytics({
      name: 'CLICK_MUMUL_LIVE_POST_VIEW_MORE',
      analytics: { PROFILE_SNO: profileSno.toString() },
    });
  }, [logMarketAnalytics, profileSno]);

  const logClickMumulLiveProfile = useCallback(() => {
    logMarketAnalytics({
      name: 'CLICK_MUMUL_LIVE_PROFILE',
      analytics: { PROFILE_SNO: profileSno.toString() },
    });
  }, [logMarketAnalytics, profileSno]);

  return {
    logDisplayMumulLivePost,
    logClickMumulLivePost,
    logClickMumulLivePostViewMore,
    logClickMumulLiveProfile,
  };
};
